// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pointItem__xGji8 {
  width: 16px;
  height: 16px;
}

.critical__nvGE5 {
  background-color: var(--legend-for-header-critical);
}

.snoozed__tFldl {
  position: relative;
}
.snoozed__tFldl:after {
  content: "";
  position: absolute;
  top: -2px;
  right: -2px;
  width: 5px;
  height: 5px;
  background-color: var(--legend-for-header-snoozed-badge);
  border-radius: 50%;
  border: 2px solid var(--legend-for-header-snoozed-badge-stroke);
}

.high__AeUdE {
  background-color: var(--legend-for-header-high);
}

.standard__Ygjny {
  background-color: var(--legend-for-header-standard);
}

.normal___Nhrt {
  background-color: var(--legend-for-header-no-ai);
}

.watchlist__Mghqa {
  background: linear-gradient(45deg, var(--legend-for-header-no-ai) 50%, #75899d 50%);
}

.detached__vSCAC {
  background-color: #d0d6e5;
}

.deactivated__jADBg {
  background-color: var(--legend-for-header-inactive);
  border: 1px solid var(--legend-for-header-inactive-stroke);
}

.inactive__catPP {
  background-color: var(--legend-for-header-inactive);
  border: 1px solid var(--legend-for-header-inactive-stroke);
}

.on_hold__EzI0p {
  background-color: var(--legend-for-header-snoozed);
  position: relative;
}
.on_hold__EzI0p:after {
  content: "";
  position: absolute;
  top: -2px;
  right: -2px;
  width: 5px;
  height: 5px;
  background-color: var(--legend-for-header-snoozed-badge);
  border-radius: 50%;
  border: 2px solid var(--legend-for-header-snoozed-badge-stroke);
}`, "",{"version":3,"sources":["webpack://./../src/pages/Sensors/components/InstallationPointItem/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,mDAAA;AAzEF;;AA2EA;EACE,kBAAA;AAxEF;AAyEE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,wDAAA;EACA,kBAAA;EACA,+DAAA;AAvEJ;;AA0EA;EACE,+CAAA;AAvEF;;AAyEA;EACE,mDAAA;AAtEF;;AAwEA;EACE,gDAAA;AArEF;;AAuEA;EACE,mFAAA;AApEF;;AAsEA;EACE,yBAAA;AAnEF;;AAqEA;EACE,mDAAA;EACA,0DAAA;AAlEF;;AAoEA;EACE,mDAAA;EACA,0DAAA;AAjEF;;AAmEA;EACE,kDAAA;EACA,kBAAA;AAhEF;AAiEE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,wDAAA;EACA,kBAAA;EACA,+DAAA;AA/DJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.pointItem {\n  width: 16px;\n  height: 16px;\n}\n\n.critical {\n  background-color: var(--legend-for-header-critical);\n}\n.snoozed {\n  position: relative;\n  &:after {\n    content: '';\n    position: absolute;\n    top: -2px;\n    right: -2px;\n    width: 5px;\n    height: 5px;\n    background-color: var(--legend-for-header-snoozed-badge);\n    border-radius: 50%;\n    border: 2px solid var(--legend-for-header-snoozed-badge-stroke);\n  }\n}\n.high {\n  background-color: var(--legend-for-header-high);\n}\n.standard {\n  background-color: var(--legend-for-header-standard);\n}\n.normal {\n  background-color: var(--legend-for-header-no-ai);\n}\n.watchlist {\n  background: linear-gradient(45deg, var(--legend-for-header-no-ai) 50%, #75899d 50%);\n}\n.detached {\n  background-color: #d0d6e5;\n}\n.deactivated {\n  background-color: var(--legend-for-header-inactive);\n  border: 1px solid var(--legend-for-header-inactive-stroke);\n}\n.inactive {\n  background-color: var(--legend-for-header-inactive);\n  border: 1px solid var(--legend-for-header-inactive-stroke);\n}\n.on_hold {\n  background-color: var(--legend-for-header-snoozed);\n  position: relative;\n  &:after {\n    content: '';\n    position: absolute;\n    top: -2px;\n    right: -2px;\n    width: 5px;\n    height: 5px;\n    background-color: var(--legend-for-header-snoozed-badge);\n    border-radius: 50%;\n    border: 2px solid var(--legend-for-header-snoozed-badge-stroke);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pointItem": `pointItem__xGji8`,
	"critical": `critical__nvGE5`,
	"snoozed": `snoozed__tFldl`,
	"high": `high__AeUdE`,
	"standard": `standard__Ygjny`,
	"normal": `normal___Nhrt`,
	"watchlist": `watchlist__Mghqa`,
	"detached": `detached__vSCAC`,
	"deactivated": `deactivated__jADBg`,
	"inactive": `inactive__catPP`,
	"onHold": `on_hold__EzI0p`
};
module.exports = ___CSS_LOADER_EXPORT___;
